<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Перевыгрузка КИ</template>
        <template #content>
          <TabView>
            <TabPanel header="Перевыгрузка КИ">
              <ResendLoansForm
                  ref="resendForm"
                  commit-label="Перевыгрузить"
                  commit-icon="pi pi-pencil"
              />
            </TabPanel>
            <TabPanel header="Отчеты на перевыгрузку КИ">
              <CorrectionReportsTable ref="requestsTable"/>
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import ResendLoansForm from "@/components/Forms/ResendLoansForm.vue";
// import DeleteInformationPartsTable from "@/components/tables/DeleteInformationPartsTable.vue";
import CorrectionReportsTable from "@/components/tables/CorrectionReportsTable.vue";

export default {
  name: 'DeleteInformationPart',
  components: {
    ResendLoansForm,
    CorrectionReportsTable
  },
  methods: {

  }
}
</script>


